"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryUniqueKey = exports.getTagUniqueKey = void 0;
function getTagUniqueKey(category, tag) {
    return tag.key || "tag-".concat(tag.id, "-").concat(tag.name, "-").concat(category.id);
}
exports.getTagUniqueKey = getTagUniqueKey;
function getCategoryUniqueKey(category) {
    return category.key || "category-".concat(category.id, "-").concat(category.name);
}
exports.getCategoryUniqueKey = getCategoryUniqueKey;
